import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyValutazioniService {
    static getTipi = (id_azienda = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/valutazioni/tipi`;
            const payload = {};
            if (id_azienda) payload.id_azienda = id_azienda;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/valutazioni/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/valutazioni/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteValutazione = (id_valutazione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/valutazioni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_valutazione });
        });
    };

    static download = (id_valutazione, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/valutazioni/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_valutazione, filename });
        });
    };
}
